import React, { useState } from 'react'
import styled from 'styled-components'

import { media, mediaMax } from 'styles/media'

import useSwiperPagination from '../../../hooks/useSwiperPagination'

import ChevronDownIcon from '../../icons/ChevronDown'

import Slider from './Slider'
import List from './List'
import { Arrow, Inner, Header, Title } from './shared'

const BREAKPOINT = 'lg' as const

const MobileOnly = styled.div`
  ${media[BREAKPOINT]`
    display: none;
  `}
`

const DesktopOnly = styled.div`
  ${mediaMax[BREAKPOINT]`
    display: none;
  `}
`

type PaginatedSlidesProps<T> = {
  customTitle?: React.ReactNode
  called: boolean
  loading: boolean
  canFetchMore: boolean
  onFetchMore: () => any
  items: T[]
  ItemComponent: React.ComponentType<{ item: T }>
  loadingPlaceholder?: React.ReactNode
  minHeight?: string
}

const PaginatedSlides = <T extends Record<'id', string>>({
  customTitle,
  called,
  loading,
  canFetchMore,
  onFetchMore,
  items,
  ItemComponent,
  loadingPlaceholder,
  minHeight,
}: PaginatedSlidesProps<T>) => {
  const [swiper, getSwiper] = useState(null)

  const [{ handlePrev, handleNext }] = useSwiperPagination(swiper)

  const paginationNotReady = !called || loading || !items

  return (
    <Inner $minHeight={minHeight}>
      <Header>
        {customTitle || <Title>More Escapes</Title>}

        <DesktopOnly>
          <Arrow left onClick={handlePrev} disabled={paginationNotReady}>
            <ChevronDownIcon />
          </Arrow>
          <Arrow right onClick={handleNext} disabled={paginationNotReady}>
            <ChevronDownIcon />
          </Arrow>
        </DesktopOnly>
      </Header>

      <DesktopOnly>
        <Slider
          getSwiper={getSwiper}
          swiperReady={swiper != null}
          loading={loading}
          canFetchMore={canFetchMore}
          onFetchMore={onFetchMore}
          items={items || []}
          ItemComponent={ItemComponent}
          loadingPlaceholder={loadingPlaceholder}
        />
      </DesktopOnly>

      <MobileOnly>
        <List
          loading={loading}
          canFetchMore={canFetchMore}
          onFetchMore={onFetchMore}
          items={items || []}
          ItemComponent={ItemComponent}
          loadingPlaceholder={loadingPlaceholder}
        />
      </MobileOnly>
    </Inner>
  )
}

export default PaginatedSlides
